import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Longlife(props) {
    return (
        <div className="tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Opportunities">
                            <h2>Opportunities For Growth & Development</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <div>
                            <p>We are a team of lifelong learners passionate about technology and innovation. At TekRevol, we believe hard work and dedication should be recognized and rewarded, which is why we have employed a transparent, yet encouraging that emphasizes attitude, performance, and results.</p>
                            <p>As a member of TekRevol, you'll have the opportunity to make positive impacts through your work and be recognized for your contributions.</p>
                            <p>We offer competitive salary packages, bi-annual performance-based increments, a comprehensive healthcare plan, provident fund facilities with matching contributions, paid time off and holidays, professional development opportunities like training and conferences, employee referral bonuses, employee assistance programs for mental health and well-being, and more!</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Longlife;